<template>
    <div :class="['screenWrap',isTask?'screenActive':'']">
    <!-- <div :class="['screenWrap']"> -->
        <div class="screenTitle">
            <span :class="[isTask&&val.id==isMock?'titleActive':'',val.isTitle?'titleActive':'']" v-for="(val,ind) in titleToggle" :key="ind" @click="titleToggles(val,ind)"> 
                <b>{{val.title}}</b>
                <i :class="['iconfont','icon-xiangxia1',val.isTitle?'titleActive':'']" v-if="!val.isFlag"></i>
                <i :class="['iconfont','icon-xiangshang1',isTask&&val.id==isMock?'titleActive':'',val.isTitle?'titleActive':'']" v-else></i>
            </span>
        </div>
        <div class="screenTask" v-if="isTask">
            <div class="qvyv" v-if="isMock==1">
                <!-- <mt-picker :slots="slots" @change="onValuesChange"></mt-picker> -->
                <div class="qvyv_content">
                    <ul class="qvyv_left">
                        <li @click="allCity()" :class="[isAll?'titleActive':'']">全部</li>
                        <li v-for="val in cityArr" :key="val.id" @click="toggleCity(val,flag=true)" :class="[val.id==cityArrIndex?'titleActive':'']">{{val.name}}</li>
                    </ul>
                    <ul class="qvyv_right">
                        <li v-for="(val,ind) in citySub" :key="ind" @click="toggleCityList(val,ind)" :class="[ind==citySubIndex?'titleActive':'']">{{val.name}}</li> 
                    </ul>
                </div>
                <div class="qvyv_button">
                    <button @click="claerBtn">清空</button>
                    <button @click="sureBtn('qvyv')">确定</button>
                </div>
            </div>
            <div class="mianji" v-else-if="isMock==2">
                <ul class="mianji_choose">
                    <li v-for="(val,key,ind) in shopArea" :key="ind" :class="[shopAreaIndex==ind?'titleActive':'']" @click="toggleArea(val,ind,key)">{{val}}</li>
                </ul>
                <!-- 自定义面积 -->
                <div class="mianji_set">
                    <h2>自定义面积<i class="iconfont icon-quxiao" v-if="form.mianjiIptD||form.mianjiIptT" @click="clearIpt('mianji',flag=true)"></i></h2>
                    <div class="mianji_selet">
                        <div class="mianji_ipt">
                            <input type="text" v-model="form.mianjiIptD" placeholder="下限" v-on:input="change('mianji',flag=true)"><span>至</span><input type="text" placeholder="上限" v-on:input="change('mianji',flag=true)" v-model="form.mianjiIptT">
                        </div>
                        <button @click="sureBtn('mianji')">确定</button>
                    </div>
                </div>
            </div>
            <div class="feiyong" v-else>
                 <div class="feiyong_content">
                    <ul class="feiyong_left">
                        <li v-for="val in moneyArr" :key="val.id" @click="toggleMoney(val.id)" :class="[val.id==money.active?'titleActive':'']">{{val.text}}</li>
                    </ul>
                    <div class="feiyong_right">
                        <ul class="feiyong_ul" v-if="money.flag">
                            <li v-for="(val,key,ind) in moneyMonth" :key="ind" @click="toggleMoneyList(val,key,ind,'month')" :class="[ind==money.index?'titleActive':'']">{{val}}</li> 
                        </ul>
                        <ul class="feiyong_ul" v-else>
                            <li v-for="(val,key,ind) in moneyReturn" :key="ind" @click="toggleMoneyList(val,key,ind,'return')" :class="[ind==money.indexList?'titleActive':'']">{{val}}</li> 
                        </ul>
                        <!-- 自定义面积 -->
                        <div class="feiyong_set" v-if="money.flag">
                            <h2>自定义价格<i class="iconfont icon-quxiao" v-if="form.feiyongIptD||form.feiyongIptT" @click="clearIpt('feiyong',flag=true)"></i></h2>
                            <div class="feiyong_selet">
                                <div class="feiyong_ipt">
                                    <input type="text" placeholder="下限" v-model="form.feiyongIptD" v-on:input="change('feiyong',flag=true)" ><span>至</span><input type="text" v-model="form.feiyongIptT" v-on:input="change('feiyong',flag=true)" placeholder="上限">
                                </div>
                                <button @click="sureBtn('feiyong')">确定</button>
                            </div>
                        </div>
                        <div class="feiyong_set" v-else>
                            <h2>自定义价格<i class="iconfont icon-quxiao" v-if="form.start_cost||form.end_cost" @click="clearIpt('feiyong',flag=false)"></i></h2>
                            <div class="feiyong_selet">
                                <div class="feiyong_ipt">
                                    <input type="text" placeholder="下限" v-model="form.start_cost" v-on:input="change('feiyong',flag=false)"><span>至</span><input type="text" v-on:input="change('feiyong',flag=false)" v-model="form.end_cost" placeholder="上限">
                                </div>
                                <button @click="sureBtn('feiyong')">确定</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="closeTask" @click="closeTask"></div>
        </div>
    </div>
</template>
<script>
// import Cookies from 'js-cookie'
export default {
    name:"Screen",
    data(){
        return{
            titleToggle: [{id:1,title:"区域",isFlag:false,isTitle:false},{id:2,title:"面积",isFlag:false,isTitle:false},{id:3,title:"费用",isFlag:false,isTitle:false}],
            isTask: false, //是否开启task
            isMock: 1,
            isLastFlag: null, 
            cityArr:[], //商圈
            citySub:[], //随着点击显示的商圈
            cityArrIndex:0,
            citySubIndex:0,
            isAll:true,
            shopArea:[], //面积
            shopAreaIndex: 0, //面积active
            moneyArr:[{id:1,text:'月租金'},{id:2,text:"转让费"}], //费用
            moneyMonth:[], //月租金
            moneyReturn:[], //转让费
            money:{
                flag:true, 
                active: 1, 
                index:0,
                indexList:0,
            },
            form: { //自定义面积
                mianjiIptD: '',
                mianjiIptT: '',
                feiyongIptD: '',
                feiyongIptT: '',
                start_cost: '',
                end_cost: '',
            },
            screenData:{ // 需要的数据
                qvyvCity: '',
                qvyvCityList: '',
                area: undefined,
                districts: undefined,
                shop_area: undefined, 
                start_area: undefined,
                end_area: undefined,
                money: undefined,
                const_range: undefined
            },
            isTitle:false, //判断是否标红
            closeTip: null,
        }
    },
    props: ['setScreenFlag','config'],
    methods: {
        // 关闭task
        closeTask(){
            // this.isTask = false
            this.titleToggles(this.titleToggle[this.isMock-1],this.isMock-1)
        },
        // 清除ipt框
        clearIpt(ipt,flag){
          if(ipt=='mianji'){
              this.form.mianjiIptD = undefined
              this.form.mianjiIptT = undefined
          }else{
              if(!flag){
                //   console.log('清除转让费')
                  this.form.start_cost = undefined
                  this.form.end_cost = undefined
              }else{
                //   console.log('清除月租金')
                  this.form.feiyongIptD = undefined
                  this.form.feiyongIptT = undefined
              }
          }
        },
        // 清空区域所选
        claerBtn(){
            this.isAll = true
            this.cityArrIndex = 0
            this.citySubIndex = 0
            this.titleToggle[0].isTitle = false
            this.titleToggle[0].title = '区域'
            this.isTitle = false
            this.screenData.qvyvCity = ''
            this.screenData.qvyvCityList = ''
            this.screenData.area = undefined
            this.screenData.districts = undefined
            var data = {
                area: this.screenData.area,
                districts: this.screenData.districts,
                shop_area: this.screenData.shop_area,
                start_area: this.form.mianjiIptD,
                end_area: this.form.mianjiIptT,
                money: this.screenData.money,
                cost_range: this.screenData.const_range,
                start_money: this.form.feiyongIptD,
                end_money: this.form.feiyongIptT,
                start_cost: this.form.start_cost,
                end_cost: this.form.end_cost
            }
            this.$emit('listenScreen',data)
            this.titleToggles(this.titleToggle[0],0)
            this.citySub = this.cityArr[0].sub
            this.isTask = false
            // 1111111
        },
        // 确定按钮
        sureBtn(flag){
            if(flag == 'qvyv'){
                var data = {
                    area: this.screenData.area,
                    districts: this.screenData.districts,
                    shop_area: this.screenData.shop_area,
                    start_area: this.form.mianjiIptD,
                    end_area: this.form.mianjiIptT,
                    money: this.screenData.money,
                    cost_range: this.screenData.const_range,
                    start_money: this.form.feiyongIptD,
                    end_money: this.form.feiyongIptT,
                    start_cost: this.form.start_cost,
                    end_cost: this.form.end_cost
                }
                this.titleToggle[0].title = this.closeTip
                if(this.titleToggle[0].title!='区域'){
                    this.titleToggle[0].isTitle = true
                    // console.log('11')
                }else{
                    this.titleToggle[0].isTitle = false
                }
                this.$emit('screenClick',false)
                this.$emit('listenScreen',data)
                this.titleToggles(this.titleToggle[0],0)
                this.isTask = false
            }else if(flag == 'mianji'){
                if(this.form.mianjiIptD == ''||this.form.mianjiIptD == undefined||this.mianjiIptD == 'undefined'){
                    this.$toast({
                        message: '起始面积输入数字',
                        position: 'middle',
                        duration: 2000
                    })
                }else if(this.form.mianjiIptT == ''||this.form.mianjiIptT == undefined||this.mianjiIptT == 'undefined'){
                    this.$toast({
                        message: '结束面积输入数字',
                        position: 'middle',
                        duration: 2000
                    })
                }else{
                    var data = {               
                        area: this.screenData.area,
                        districts: this.screenData.districts,
                        shop_area: this.screenData.shop_area,
                        start_area: this.form.mianjiIptD,
                        end_area: this.form.mianjiIptT,
                        money: this.screenData.money,
                        cost_range: this.screenData.const_range,
                        start_money: this.form.feiyongIptD,
                        end_money: this.form.feiyongIptT,
                        start_cost: this.form.start_cost,
                        end_cost: this.form.end_cost
                    }
                    this.titleToggle[1].title = '面积'
                    this.titleToggle[1].isTitle = true
                    this.$emit('screenClick',false)
                    this.$emit('listenScreen',data)
                    this.isTask = false
                    this.titleToggles(this.titleToggle[1],1)
                }
            }else{
                if(this.money.flag){
                    if(this.form.feiyongIptD == '' || this.form.feiyongIptD == undefined||this.form.feiyongIptD == 'undefined'){
                        this.$toast({
                            message: '起始价格输入数字',
                            position: 'middle',
                            duration: 2000
                        })
                    }else if(this.form.feiyongIptT == '' || this.form.feiyongIptT == undefined||this.feiyongIptT == 'undefined'){
                        this.$toast({
                            message: '结束价格输入数字',
                            position: 'middle',
                            duration: 2000
                        })
                    }else{
                            var data = {               
                            area: this.screenData.area,
                            districts: this.screenData.districts,
                            shop_area: this.screenData.shop_area,
                            start_area: this.form.mianjiIptD,
                            end_area: this.form.mianjiIptT,
                            money: this.screenData.money,
                            cost_range: this.screenData.const_range,
                            start_money: this.form.feiyongIptD,
                            end_money: this.form.feiyongIptT,
                            start_cost: this.form.start_cost,
                            end_cost: this.form.end_cost
                        }
                        this.titleToggle[2].title = '费用'
                        this.titleToggle[2].isTitle = true
                        this.$emit('screenClick',false)
                        this.$emit('listenScreen',data)
                        this.isTask = false
                        this.titleToggles(this.titleToggle[2],2)
                    }
                }else{
                    if(this.form.start_cost == '' || this.form.start_cost == undefined||this.form.start_cost == 'undefined'){
                        this.$toast({
                            message: '起始价格输入数字',
                            position: 'middle',
                            duration: 2000
                        })
                    }else if(this.form.end_cost == '' || this.form.end_cost == undefined||this.end_cost == 'undefined'){
                        this.$toast({
                            message: '结束价格输入数字',
                            position: 'middle',
                            duration: 2000
                        })
                    }else{
                            var data = {               
                            area: this.screenData.area,
                            districts: this.screenData.districts,
                            shop_area: this.screenData.shop_area,
                            start_area: this.form.mianjiIptD,
                            end_area: this.form.mianjiIptT,
                            money: this.screenData.money,
                            cost_range: this.screenData.const_range,
                            start_money: this.form.feiyongIptD,
                            end_money: this.form.feiyongIptT,
                            start_cost: this.form.start_cost,
                            end_cost: this.form.end_cost
                        }
                        this.titleToggle[2].title = '费用'
                        this.titleToggle[2].isTitle = true
                        this.$emit('screenClick',false)
                        this.$emit('listenScreen',data)
                        this.isTask = false
                        this.titleToggles(this.titleToggle[2],2)
                    }
                }

                
            }
        },
        //监听input框的变化
        change(txt,flag){
            if(txt == 'mianji'){
                this.shopAreaIndex = undefined
                this.screenData.shop_area = undefined
            }else{
                if(!flag){
                    // console.log(this.form.start_cost,this.form.end_cost)
                    this.money.indexList = undefined
                    this.screenData.const_range = undefined
                }else{
                    this.money.index = undefined
                    this.screenData.money = undefined
                }
            }
        },
        // 费用
        toggleMoney(id){
            this.money.active = id
            if(id==1){
                this.money.flag = true
            }else{
                this.money.flag = false
            }
        },
        // 月租金+转让费
        toggleMoneyList(val,key,ind,flag){
            this.titleToggle[2].title = val
            this.titleToggle[2].isTitle = true
            if(flag == 'month'){
                this.screenData.money = key
                this.money.index = ind
            }else if(flag == 'return'){
                this.screenData.const_range = key
                this.money.indexList = ind
            }
            var data = {               
                area: this.screenData.area,
                districts: this.screenData.districts,
                shop_area: this.screenData.shop_area,
                start_area: this.form.mianjiIptD,
                end_area: this.form.mianjiIptT,
                money: this.screenData.money,
                cost_range: this.screenData.const_range,
                start_money: this.form.feiyongIptD,
                end_money: this.form.feiyongIptT,
                start_cost: this.form.start_cost,
                end_cost: this.form.end_cost
            }
            this.$emit('screenClick',false)
            this.$emit('listenScreen',data)
            this.isTask = false
            this.titleToggles(this.titleToggle[2],2)
        },
        // 切换面积
        toggleArea(val,ind,key){
            this.shopAreaIndex = ind
            this.screenData.shop_area = key
            this.titleToggle[1].title = val
            this.isMock = 2
            this.titleToggle[1].isTitle = true
            if(ind == 0){
                var data = {
                    area: this.screenData.area,
                    districts: this.screenData.districts,
                    shop_area: undefined,
                    start_area: this.form.mianjiIptD,
                    end_area: this.form.mianjiIptT,
                    money: this.screenData.money,
                    cost_range: this.screenData.const_range,
                    start_money: this.form.feiyongIptD,
                    end_money: this.form.feiyongIptT,
                    start_cost: this.form.start_cost,
                    end_cost: this.form.end_cost
                }
            }else{
                var data = {               
                    area: this.screenData.area,
                    districts: this.screenData.districts,
                    shop_area: this.screenData.shop_area,
                    start_area: this.form.mianjiIptD,
                    end_area: this.form.mianjiIptT,
                    money: this.screenData.money,
                    cost_range: this.screenData.const_range,
                    start_money: this.screenData.start_money,
                    end_money: this.screenData.end_money,
                    start_cost: this.screenData.start_cost,
                    end_cost: this.screenData.end_cost
                }
            }
            this.$emit('screenClick',false)
            this.$emit('listenScreen',data)
            this.isTask = false
            this.titleToggles(this.titleToggle[1],1)
        },
        // 切换商圈
        toggleCity(val,flag=true){
            this.screenData.qvyvCity = val.name
            this.citySub = val.sub
            this.isAll = false
            this.citySubIndex = 0
            this.closeTip = val.name
            this.screenData.area = val.id
            this.screenData.districts = val.id+'-'+0
            if(flag){
                this.cityArrIndex = val.id
            }
            return
        }, 
        // 商圈list切换
        toggleCityList(val,ind){
            this.closeTip = val.name
            this.screenData.qvyvCityList = val.name
            if(this.screenData.area == undefined){
                this.screenData.area = 1
            }
            this.screenData.districts = this.screenData.area+'-'+val.id
            this.citySubIndex = ind
        },
        // 点击全部
        allCity(){
            this.isAll = true
            this.titleToggle[0].title = '全部'
            this.cityArrIndex = 0
            this.citySubIndex = 0
            this.citySub = this.cityArr[0].sub
            this.screenData.area = undefined
            this.screenData.districts = undefined
            this.screenData.qvyvCity = ''
            this.screenData.qvyvCityList = ''
        },
        // 控制箭头
        titleToggles(val,index){
            this.isMock = val.id
            if(index == this.isLastFlag){
                this.isTask = false
                this.isLastFlag = null
                this.titleToggle[index].isFlag = !val.isFlag
                this.canScroll()
                this.$emit('screenClick',false)
                return
            }
            this.isLastFlag = index
            this.$emit('screenClick',true)
            this.titleToggle.map((val,ind)=>{
                val.isFlag = false
            })
            this.titleToggle[index].isFlag = !val.isFlag
            if(val.isFlag){
                this.isTask = true
                this.stopScroll()
            }
        },
        // 停止滚动
        stopScroll(){
            var mo=function(e){e.preventDefault();};
            document.body.style.overflow='hidden';
            document.addEventListener("touchmove",mo,false);//禁止页面滑动
        },
        // 取消滑动限制
        canScroll(){
            var mo=function(e){e.preventDefault();};
            document.body.style.overflow='';//出现滚动条
            document.removeEventListener("touchmove",mo,false);
        },
        // 获取弹窗信息
        // getStreetData(){
        //     // this.ajax.get('//api.lepu.cn/app/shop/config').then(res=>{
        //     //     var res = res.data
        //     //     if(res.data.code==1){
        //     //         this.cityArr = data.config.city // 商圈
        //     //         this.shopArea = data.config.shop_area // 面积
        //     //         this.moneyMonth = data.config.money //月租金
        //     //         this.moneyReturn = data.config.cost_range //转让费
        //     //         this.citySub = this.cityArr[this.cityArrIndex].sub
        //     //         // this.allCity()
        //     //     }
        //     // })

        //     this.citySub = this.cityArr[this.cityArrIndex].sub
        // }
    },
    watch: {
        setScreenFlag(val){
            this.isAll = true
            this.cityArrIndex = 0
            this.citySubIndex = 0
            this.screenData.qvyvCity = ''
            this.screenData.qvyvCityList = ''
            this.shopAreaIndex = 0
            this.form.mianjiIptD = ''
            this.form.mianjiIptT = ''
            this.form.feiyongIptD = ''
            this.form.feiyongIptT = ''
            this.form.start_cost = ''
            this.screenData = {
                area: undefined,
                districts: undefined,
                shop_area: undefined, 
                start_area: undefined,
                end_area: undefined,
                money: undefined,
                cost_range: undefined,
                start_money: undefined,
                end_money: undefined,
                start_cost: undefined,
                end_cost: undefined
            },
            this.titleToggle = [{id:1,title:"区域",isFlag:false,isTitle:false},{id:2,title:"面积",isFlag:false,isTitle:false},{id:3,title:"费用",isFlag:false,isTitle:false}]
            this.money = {
                flag:true, 
                active: 1, 
                index:0,
                indexList:0
            }
        },
        config(val){
            this.cityArr = val.city // 商圈
            this.shopArea = val.shop_area // 面积
            this.moneyMonth = val.money //月租金
            this.moneyReturn = val.cost_range //转让费
            this.citySub = this.cityArr[this.cityArrIndex].sub
        }
    },
    mounted(){

    }
}
</script>
<style lang="scss" scoped>
.screenWrap{
    width: 100%;
    height: 100%;

    .screenTitle{
        width: 100%;
        background: #fff;
        height: 1rem;
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 .8rem;
        box-sizing: border-box;

            span{
                display: inline-block;
                display: flex;
                height: 100%;
                align-items: center;
                justify-content: center;
                line-height: 1rem;
                font-size: .3rem;

                &>i{
                    font-size: .2rem;
                    color: rgb(94, 70, 70);
                }

                b{
                    font-weight: normal;
                    display: inline-block;
                    max-width: 1.4rem;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                }
            }
    }

    .screenTask{
        position: fixed;
        top: 1.8rem;
        left: 0;
        right:0;
        bottom:0;
        background: rgba(0,0,0,.5);
        display: flex;
        flex-direction: column;

        .closeTask{
            width: 100%;
            flex: 1;
            background: none;
        }
    }
}

.screenActive{
    // position: fixed;
    // top: 0;
    // left: 0;
    // right: 0;
    // bottom: 0;
}

.qvyv{
    width: 100%;
    background: #fff;

    .qvyv_content{
        width: 100%;
        height: 3.47rem;
        display: flex;
        font-size: .3rem;

        .qvyv_left{
            width: 50%;
            height: 100%;
            text-align: center;
            background: #fff;
            // font-weight: 600;
            overflow: scroll;

            li{
                height:1rem;
                line-height: 1rem;
            }
        }

        .qvyv_right{
            flex: 1;
            height: 100%;
            text-align: center;
            background: #f5f5f5;
            color: #333;
            overflow: scroll;

            li{
                height:1rem;
                line-height: 1rem;
            }
        }
    }

    .qvyv_button{
        width: 100%;
        height: 1rem;
        display: flex;

        button{
            width: 50%;
            height: 100%;
            line-height: .1rem;
            text-align: center;
            background: #fff;
            color: #999;
            font-size: .3rem;

            &:nth-child(2){
                background: #ce1d2e;
                color: #fff;
                border:none
            }
        }
    }
}

.mianji{
    width: 100%;
    background: #fff;

    .mianji_choose{
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        padding: .26rem .3rem 0;
        box-sizing: border-box;

        li{
            width: 2.1rem;
            height: .7rem;
            line-height: .7rem;
            text-align: center;
            background: #f5f5f5;
            border: .02rem solid #ddd;
            border-radius: .06rem;
            margin-bottom: .2rem;
            font-size: .3rem;
            margin-right: 2%;
        }
    }

    .mianji_set{
        width: 100%;
        border-top: 0.02rem solid #ddd;
        padding:.3rem;
        box-sizing: border-box;

        &>h2{
            width: 100%;
            height: .24rem;
            font-size: .24rem;
            border-left: .05rem solid #e22222;
            padding-left: .1rem;
            box-sizing: border-box;
            line-height: .26rem;

            i{
                font-size: .24rem;
                color: #e22222;
                margin-left: .1rem;
            }
        }

        .mianji_selet{
            width: 100%;
            display: flex;
            align-items: center;

            .mianji_ipt{
                display: flex;
                align-items: center;

                input{
                    width: 1.1rem;
                    height: 0.44rem;
                    border: none;
                    border-bottom: 0.02rem solid #999;
                    border-radius: none!important;
                    font-size: 0.24rem;
                    padding: 0 0.21rem;
                    background: none;
                    text-align: center;
                    border-radius: 0;  
                }

                input::-webkit-input-placeholder{
                    color: #999;
                }

                span{
                    padding: 0 .2rem;
                    box-sizing: border-box;
                }

            }

            button{
                width: 2.1rem;
                height: .7rem;
                line-height: .7rem;
                font-size: .24rem;
                text-align: center;
                color: #fff;
                background: #e22222;
                margin-left: 5%;
                border: none;
            }
        }
    }
}

.feiyong{
    width: 100%;
    height: 4.6rem;

    .feiyong_content{
        width: 100%;
        height: 100%;
        display: flex;

        .feiyong_left{
            width: 35%;
            height: 100%;
            display: flex;
            padding-bottom: .5rem;
            box-sizing: border-box;
            justify-content: center;
            flex-direction: column;
            text-align: center;
            background: #fff;
            overflow: scroll;

            li{
                height:1rem;
                line-height: 1rem;
                font-size: .3rem;
            }
        }

        .feiyong_right{
            flex: 1;
            height: 100%;
            text-align: center;
            background: #f5f5f5;
            color: #333;

            .feiyong_ul{
                width: 100%;
                height: 70%;
                overflow: scroll;

                li{
                    height:1rem;
                    line-height: 1rem;
                    font-size: .3rem;
                }
            }

            .feiyong_set{
                width: 100%;
                padding:.2rem .3rem .2rem;
                box-sizing: border-box;

                &>h2{
                    width: 100%;
                    height: .24rem;
                    font-size: .24rem;
                    border-left: .05rem solid #e22222;
                    padding-left: .1rem;
                    box-sizing: border-box;
                    line-height: .26rem;
                    text-align: left;
                    margin-bottom: .1rem;


                    i{
                        font-size: .24rem;
                        color: #e22222;
                        margin-left: .1rem;
                    }
                }

                .feiyong_selet{
                    width: 100%;
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    .feiyong_ipt{
                        display: flex;
                        align-items: center;

                        input{
                            width: .6rem;
                            height: 0.44rem;
                            border: none;
                            border-bottom: 0.02rem solid #999;
                            border-radius: none!important;
                            font-size: 0.24rem;
                            padding: 0 0.21rem;
                            background: none;
                            text-align: center;
                            border-radius: 0;  
                        }

                        input::-webkit-input-placeholder{
                            color: #999;
                        }

                        span{
                            padding: 0 .2rem;
                            box-sizing: border-box;
                        }

                    }

                    button{
                        width: 1.1rem;
                        height: .6rem;
                        line-height: .6rem;
                        font-size: .24rem;
                        text-align: center;
                        color: #fff;
                        background: #e22222;
                        margin-left: 5%;
                        border: none;
                        border-radius: .05rem;
                    }
                }
            }
        }
    }
}

.titleActive{
    color: #ce1d2e!important;
}
</style>